<template>
    <div class="addtext_font align_value">
        <div class="form-group">
            <div class="layer_parent_div left_margin_zero height-30">
                <button
                    @click="setFontWeight('bold')"
                    :class="'bcommon b1  ' + setFontWeightActive('bold')"
                >
                    <img class="height-width-17" src="./icon/bold.png" />
                </button>
                <button
                    @click="setFontStyle('italic')"
                    :class="'bcommon  ' + setFontStyleActive('italic')"
                >
                    <img class="height-width-17" src="./icon/italics.png" />
                </button>
                <button
                    @click="setTextDecoration('linethrough')"
                    :class="'bcommon b2  ' + setDecoratorActive('linethrough')"
                >
                    <img
                        class="height-width-17"
                        src="./icon/strikethrough.png"
                    />
                </button>
                <button
                    @click="setUDecoration('underline')"
                    :class="'bcommon b2  ' + setUDecoratorActive('underline')"
                >
                    <img
                        class="height-width-17"
                        src="./icon/underline-text.png"
                    />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FontStyle",
    props: ["textDecoration", "fontWeight", "fontStyle", "textUDecoration"],
    data: () => {
        return {};
    },
    methods: {
        setFontWeight(e) {
            this.$emit(
                "set-fontWeight-value",
                this.fontWeight == e ? "100" : e
            );
        },
        setFontWeightActive(e) {
            return e == this.fontWeight ? "active" : "";
        },
        setFontStyle(e) {
            this.$emit("set-fontStyle-value", this.fontStyle == e ? "" : e);
        },
        setFontStyleActive(e) {
            return e == this.fontStyle ? "active" : "";
        },
        //Created by drashti on 4th Aug
        setDecoratorActive(e) {
            return e == this.textDecoration ? "active" : "";
        },
        setTextDecoration(e) {
            this.$emit(
                "set-textDecoration-value",
                !this.textDecoration ? e : ""
            );
        },
        setUDecoratorActive(e) {
            return e == this.textUDecoration ? "active" : "";
        },
        setUDecoration(e) {
            this.$emit("set-UDecoration-value", !this.textUDecoration ? e : "");
        }
        //Created by drashti on 4th Aug
    }
};
</script>

<style>
.left_margin_zero {
    margin-left: 0px !important;
}

.height-30 {
    height: 32px !important;
    margin-top: 17px !important;
}

.height-width-17 {
    height: 17px !important;
    width: 17px !important;
    margin: 0px 8px !important;
}
</style>
